/* Gloomee cart upsells — URL suppression + micro-interactions */
(function () {
  if (window.__gloomeeCartUpsellsLoaded) return;
  window.__gloomeeCartUpsellsLoaded = true;

  function shouldHide(rule, params) {
    if (!rule) return false;
    rule = String(rule).trim().replace(/^\?/, '');
    if (!rule) return false;
    var ampIndex = rule.indexOf('&');
    if (ampIndex > -1) rule = rule.slice(0, ampIndex);
    var equalIndex = rule.indexOf('=');
    if (equalIndex > -1) {
      var key = decodeURIComponent(rule.slice(0, equalIndex).trim());
      var expected = decodeURIComponent(rule.slice(equalIndex + 1).trim());
      return key ? params.get(key) === expected : false;
    }
    return params.has(decodeURIComponent(rule));
  }

  function processBlock(block) {
    if (!block || block.nodeType !== 1) return;
    var rule = block.getAttribute('data-gloomee-hide-param');
    if (!rule) {
      block.removeAttribute('data-gloomee-url-pending');
      return;
    }
    var params = new URLSearchParams(window.location.search);
    if (shouldHide(rule, params)) {
      block.remove();
      return;
    }
    block.removeAttribute('data-gloomee-url-pending');
  }

  function scan(root) {
    if (!root || (root.nodeType !== 1 && root !== document)) return;
    if (root.matches && root.matches('[data-gloomee-upsell-block]')) processBlock(root);
    if (root.querySelectorAll) root.querySelectorAll('[data-gloomee-upsell-block]').forEach(processBlock);
  }

  function replayCardAnimation(card) {
    if (!card) return;
    card.classList.remove('gloomee-upsell-card--clicked');
    void card.offsetWidth;
    card.classList.add('gloomee-upsell-card--clicked');
    window.setTimeout(function () { card.classList.remove('gloomee-upsell-card--clicked'); }, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  } else {
    scan(document);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(
      '.gloomee-upsell-card .upsell__add-btn, ' +
      '.gloomee-upsell-card .upsell-toggle-btn, ' +
      '.gloomee-upsell-card .upsell__plus-btn, ' +
      '.gloomee-upsell-card .upsell__checkbox'
    );
    if (!trigger || trigger.disabled) return;
    replayCardAnimation(trigger.closest('.gloomee-upsell-card'));
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) scan(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
